import httpRequset from 'liSrv';
export default {
  login({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.login(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  setFontColor({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.setFontColor(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  getCode({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getCode(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  resetPwd({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.resetPwd(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  resetPwdNoVc({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.resetPwdNoVc(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  regCode({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.regCode(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  verifyCodeLogin({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.verifyCodeLogin(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
          ok && commit('saveLoginInfo', { res });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  getLoginInfo({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.animalLogin(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
          ok && commit('saveLoginInfo', { res, userPwd: data.password });
        },
        (res) => {
          reject(res);
        },
      );
    });
  },
  getClassPageBaseData({ commit }, data) {
    //获取班级列表页数据
    return new Promise((reslove, reject) => {
      httpRequset.getClassPageBaseData(
        data.data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
          if (!ok) return;
          let coinAllnum = res.studentInfo.totalCoin || 0;
          let userBadgeNum = res.studentInfo.totalBadge || 0;
          let avatar_url =
            res.studentInfo.avatarUrl || '/static/img/common/defaultImg.png'; //没有值的，为默认头像
          let realname = res.studentInfo.realName;
          let is_unread = res.studentInfo.isUnread;
          let internal_users = res.studentInfo.internalUsers == 1;
          let headwearUrl = res.studentInfo.headwearUrl;
          let isGhost = res.studentInfo.isGhost == 1;
          commit('saveUserInfo', {
            internal_users,
            coinAllnum,
            userBadgeNum,
            avatar_url,
            realname,
            is_unread,
            headwearUrl,
            isGhost,
          });
          let grade = res.courseWareGame.grade || 1;
          let kejianGameList = res.courseWareGame.list[grade];
          if (!kejianGameList) {
            for (const key in res.courseWareGame.list) {
              grade = key * 1;
              break;
            }
          }
          commit('setLastGrade', grade);
        },
        (err) => {
          reject(err);
        },
        data.config,
      );
    });
  },
  getClassList(context, data) {
    //获取班级列表页数据
    return new Promise((reslove, reject) => {
      httpRequset.getClassList(
        data.data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
        data.config,
      );
    });
  },
  //获取服务器实时时间
  getServerTime({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getServerTime(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getLessonList({ commit }, data) {
    //获取课时列表页数据
    return new Promise((reslove, reject) => {
      httpRequset.getLessonList(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject();
        },
      );
    });
  },
  getExperienceLessonList({ commit }, data) {
    //获取体验课列表页数据
    return new Promise((reslove, reject) => {
      httpRequset.getExperienceLessonList(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (res) => {
          reject();
        },
      );
    });
  },
  //获取当前用户的徽章
  usercenterBadgeList({}, data) {
    return new Promise((reslove, reject) => {
      httpRequset.usercenterBadgeList(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取标准问答
  getStandardQuestion({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.standardQuestion(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取体验课标准问答
  getStandardQuestionExp({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.standardQuestionExp(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //回放页获取标准问答
  getStandardQuestionPlayBack({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.standardQuestionPlayBack(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取快速问答
  getQuickQuestion({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.quickQuestion(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取资源文件（音频）
  getZip({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getZip(
        data,
        (res, ok) => {
          ok && commit('downloadKeJianZip', res);
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getKejianJson({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getKejianJson(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },

  //获取默认头像列表
  getDefaultPhotoList({}, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getDefaultPhotoList(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //退课
  lessonOut({}, data) {
    return new Promise((reslove, reject) => {
      httpRequset.lessonOut(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  // 退课-录播课
  recordLessonOut({}, data) {
    return new Promise((reslove, reject) => {
      httpRequset.recordLessonOut(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //api获取长连接数据函数
  getMsgClient({}, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getMsgClient(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取流地址
  getPullUrl({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getPullUrl(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
          ok && commit('saveVideoUrl', res || []);
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //修改用户头像
  modifyPhoto({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.modifyPhoto(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
          ok && commit('changePhoto', res);
        },
        (err) => {
          reject(err);
        },
      );
    });
  },

  //获取课程状态
  getLessonsState({}, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getLessonsState(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //进课
  lessonIn({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.lessonIn(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
          ok && commit('saveLessonInInfo', res);
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取发题记录
  getSendLog({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getSendLog(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取发题记录-录播课
  getSendLogForRecord({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getSendLogForRecord(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getLatestVersion(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getLatestVersion(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },

  /**
   * 课前测答案上报接口
   * @param {*} data
   */
  sendPreQuestion(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.sendPreQuestion(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  /**
答题排行榜
 */
  getAnswerRank(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getAnswerRank(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getBadgeRank(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getBadgeRank(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getPraiseInfo(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getPraiseInfo(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //获取消息列表
  getMsgList(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getMsgList(
        data.data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
        data.config,
      );
    });
  },
  //获取消息详情
  getMsgDetail(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getMsgDetail(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //删除单条消息
  delMessage(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.delMessage(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //徽章上报
  uploadBadge(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.uploadBadge(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //问题反馈
  problemFeedback({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.problemFeedback(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getBugTyptList({}, data) {
    return new Promise((reslove, reject) => {
      httpRequset.getBugTyptList(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getOssToken(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getOssToken(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  uploadOssSuccess(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.uploadOssSuccess(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  uplodeTelephoneError(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.uplodeTelephoneError(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  //直播页获取资源
  getImageResources({ commit }, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getImageResources(
        data,
        (res, ok) => {
          resolve({ res, ok });
          if (ok) {
            let continuousRightConfig = {},
              danmuStyleList = {};
            if (res.continuousRightConfig) {
              res.continuousRightConfig.list.forEach((item) => {
                continuousRightConfig[item.level] = item;
              });
            }
            if (res.barrageStyle) {
              res.barrageStyle.list.forEach((item) => {
                danmuStyleList[item.styleId] = item;
              });
            }
            commit('saveDanmuConfig', {
              imgBaseUrl: res.barrage.baseUrl,
              continuousRightConfig,
              danmuStyleList,
              myDanmuStyleId: res.barrageStyle.barrageStyleId,
              continuousRightBaseUrl: res.continuousRightConfig.baseUrl,
            });
          }
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  durationRport(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.durationRport(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  apiSendGift(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.apiSendGift(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  sendPkData(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.sendPkData(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  getPlaybackSendLog(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getPlaybackSendLog(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  exerciseIndex(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.exerciseIndex(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  clearExercise(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.clearExercise(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  exerciseQuestionSave(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.exerciseQuestionSave(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  exerciseSubmit(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.exerciseSubmit(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  exerciseCorrect(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.exerciseCorrect(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  /**
   * 获取快速问答选择题样式
   */
  getXuanZeStyle(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getXuanZeStyle(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  /**
   * 获取头饰列表
   * @returns {Promise<unknown>}
   */
  getHeadwearList(context, data) {
    return new Promise((resolve, reject) => {
      httpRequset.getHeadwearList(
        data,
        (res, ok) => {
          resolve({ res, ok });
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
  /**
   * 修改用户头饰
   * @param context
   * @param data
   * @returns {Promise<unknown>}
   */
  updateHeadwear({ commit }, data) {
    return new Promise((reslove, reject) => {
      httpRequset.updateHeadwear(
        data,
        (res, ok) => {
          reslove({
            res,
            ok,
          });
          ok && commit('changeHeadwear', res);
        },
        (err) => {
          reject(err);
        },
      );
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/action.js